import { useEffect, useState } from 'react';

// Measure the rendered border box so wrapped text, safe areas and zoom can grow
// a header/banner without hiding fixed map controls underneath it.
export default function useElementHeight(initialHeight = 0) {
  const [element, setElement] = useState(null);
  const [height, setHeight] = useState(initialHeight);
  useEffect(() => {
    if (!element) { setHeight(initialHeight); return undefined; }
    let active = true;
    const measure = () => {
      if (!active) return;
      const next = Math.ceil(element.getBoundingClientRect().height);
      if (Number.isFinite(next) && next >= 0) setHeight(next);
    };
    measure();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    observer?.observe(element);
    window.addEventListener('resize', measure);
    return () => { active = false; observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, [element, initialHeight]);
  return [setElement, height];
}
